module.exports = __webpack_public_path__ + "d33a6bf089cc4c821fba7cc22acc1a5e.svg";